// extracted by mini-css-extract-plugin
export default {"root":"FieldCurrencyInput_root__JuXIG","invalid":"FieldCurrencyInput_invalid__ap0Kv"};